import React from 'react';
import { Message } from '../../../types/chat';
import { MessageContent } from './MessageContent';
import { motion } from 'framer-motion';
import { cn } from '../../../utils/cn';

interface ChatMessageProps {
  message: Message;
  isFirstMessage?: boolean;
  isLastMessage?: boolean;
}

export function ChatMessage({ message, isFirstMessage, isLastMessage }: ChatMessageProps) {
  // Format time to display
  const formatTime = (date: Date) => {
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };

  const isUser = message.sender === 'user';
  
  return (
    <motion.div 
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ 
        duration: 0.3,
        delay: isLastMessage ? 0 : 0
      }}
      className={cn(
        "flex mb-2",
        isUser ? "justify-end" : "justify-start"
      )}
    >
      <div
        className={cn(
          "max-w-[75%] rounded-lg p-2 relative shadow-message",
          isUser 
            ? "bg-chat-user text-gray-800 rounded-tr-none border border-chat-userBorder" 
            : "bg-chat-assistant text-gray-800 rounded-tl-none border border-chat-assistantBorder"
        )}
      >
        <MessageContent content={message.content} />
        
        <div className="flex items-center justify-end mt-1">
          <span className="text-[10px] text-gray-500">
            {formatTime(message.timestamp instanceof Date ? message.timestamp : new Date(message.timestamp))}
          </span>
        </div>
        
        {/* Message tail */}
        <div 
          className={cn(
            "absolute top-0 w-3 h-3",
            isUser 
              ? "right-0 transform translate-x-[98%] bg-chat-user border-t border-r border-chat-userBorder" 
              : "left-0 transform -translate-x-[98%] bg-chat-assistant border-t border-l border-chat-assistantBorder"
          )}
          style={{
            clipPath: isUser 
              ? 'polygon(0 0, 0% 100%, 100% 0)' 
              : 'polygon(0 0, 100% 0, 100% 100%)'
          }}
        />
      </div>
    </motion.div>
  );
}